import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPost, operationsClient } from '@/lib/api';
import { jobPipelineEndpoints } from '@/lib/api/endpoints';
import { jobPipelineKeys } from '@/lib/queryKeys';
import type { CreateStageDto, PipelineStage } from '@/types/pipeline';

export const useCreateStage = createMutationHook<
  PipelineStage,
  CreateStageDto & { pipelineId: string }
>({
  mutationFn: ({ pipelineId, ...dto }) =>
    apiPost<PipelineStage, CreateStageDto>(
      operationsClient,
      jobPipelineEndpoints.stages(pipelineId),
      dto,
    ),
  onSuccess: (_data, vars, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: jobPipelineKeys.detail(vars.pipelineId) });
    void queryClient.invalidateQueries({ queryKey: jobPipelineKeys.lists() });
    toast.success('Stage added');
  },
});
